import { useState, useEffect } from "react";

export const useFormMessages = ({ message, onResetForm, setValidateForm }) => {
  // Datos del hook ----------------------------------------//

  // States ------------------------------------------------//
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [hasResetForm, setHasResetForm] = useState(false);

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (formSubmitted) {
      if (message?.type === "success" && !hasResetForm) {
        setValidateForm?.(false);
        onResetForm?.();
        setHasResetForm(true);
      }
    }
  }, [formSubmitted, message, onResetForm]);

  useEffect(() => {
    if (!message) {
      setHasResetForm(false);
    }
  }, [message]);

  const showSuccessMessage = formSubmitted && message?.type === "success";
  const showErrorMessage = formSubmitted && message?.type === "error";

  return {
    formSubmitted,
    setFormSubmitted,
    showSuccessMessage,
    showErrorMessage,
    messageText: showSuccessMessage || showErrorMessage ? message?.text : "",
  };
};
